import "core-js/modules/es6.object.assign";

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import _ from 'lodash';
import moment from 'moment-strftime';
import components, { Layout } from '../components/index';
import { getPages, Link, safePrefix } from '../utils';

var Home =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Home, _React$Component);

  function Home() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Home.prototype;

  _proto.render = function render() {
    var _this = this;

    var display_posts = _.orderBy(getPages(this.props.pageContext.pages, '/posts'), 'frontmatter.date', 'desc');

    return React.createElement(Layout, this.props, _.map(_.get(this.props, 'pageContext.frontmatter.sections'), function (section, section_idx) {
      var GetSectionComponent = components[_.get(section, 'component')];

      return React.createElement(GetSectionComponent, Object.assign({
        key: section_idx
      }, _this.props, {
        section: section,
        site: _this.props.pageContext.site
      }));
    }), React.createElement("div", {
      className: "post-feed"
    }, _.map(display_posts, function (post, post_idx) {
      return React.createElement("article", {
        key: post_idx,
        className: "post post-card"
      }, React.createElement("div", {
        className: "post-card-inside"
      }, React.createElement("div", {
        className: "post-card-content"
      }, React.createElement("header", {
        className: "post-header"
      }, React.createElement("div", {
        className: "post-meta"
      }, React.createElement("time", {
        className: "published",
        dateTime: moment(_.get(post, 'frontmatter.date')).strftime('%Y-%m-%d %H:%M')
      }, moment(_.get(post, 'frontmatter.date')).strftime('%B %d, %Y'))), React.createElement("h2", {
        className: "post-title"
      }, React.createElement(Link, {
        to: safePrefix(_.get(post, 'url')),
        rel: "bookmark"
      }, _.get(post, 'frontmatter.title')))))));
    })));
  };

  return Home;
}(React.Component);

export { Home as default };